import React, { Component } from 'react'
import moment from 'moment'
import { Icon, message } from 'antd'
// import './icon.scss';

class NewCommentReply extends Component {
  constructor(props) {
    super(props)
    this.state = {
      likedSubComment: false
    }
  }

  componentWillReceiveProps(nextProps) {
    const { subcomment, profile } = nextProps
    if (profile.uid) {
      if (subcomment.likers.includes(profile.uid)) {
        this.setState({
          likedSubComment: true
        })
      } else {
        this.setState({
          likedSubComment: false
        })
      }
    }

  }

  onLikeSubComment = (e) => {
    e.preventDefault()
    const { subcomment, profile, postId, commentId } = this.props
    if (!profile.uid) {
      message.error('You need to be logged in!');
    } else {
      var likers = subcomment.likers
      likers.push(profile.uid)
      var commentDetails = {
        postId,
        subcommentId: subcomment.id,
        likers,
        commentId
      }
      this.props.likeSubComment(commentDetails)
    }
  }

  onDislikeSubComment = (e) => {
    e.preventDefault()
    const { subcomment, profile, postId, commentId } = this.props
    if (!profile.uid) {
      message.error('You need to be logged in!');
    } else {
      var likers = subcomment.likers
      var index = likers.indexOf(profile.uid)
      if (index > -1) {
        likers.splice(index, 1);
      }
      var commentDetails = {
        postId,
        subcommentId: subcomment.id,
        likers,
        commentId
      }
      this.props.unLikeSubComment(commentDetails)
    }
  }

  render() {
    const { subcomment } = this.props
    const { likedSubComment } = this.state

    return (
      <div className="single-commnet clearfix reply-comment">
        <img src="/img/user.png" alt="" className="float-left" />
        <div className="comment float-left">
          <div className="clearfix">
            <h6 className="float-left">{subcomment.commenterName}</h6>
            <span className="float-right">{moment(subcomment.created).fromNow()}</span>
          </div>
          <p>{subcomment.content}</p>
          <ul>
            <li className="likeornot">
              {
                likedSubComment ? <a href="#" onClick={(e) => this.onDislikeSubComment(e)}>
                  <Icon type="dislike" theme="filled" />
                  {subcomment.likes}
                </a> : <a href="#" onClick={(e) => this.onLikeSubComment(e)}>
                    <Icon type="like" theme="filled" />
                    {subcomment.likes}
                  </a>
              }
            </li>
            {/* <li><a href="#"><i className="fa fa-share" aria-hidden="true"></i> Reply</a></li> */}
          </ul>
        </div>
      </div>
    )
  }
}

export default NewCommentReply